module.exports = __webpack_public_path__ + "assets/eco.2b13f650.svg";